import React, { useState, useEffect, useRef } from "react";
import "./OpportunityTimeline.css"; // Ensure this file is linked

const TimelineItem = ({ title, size, side }) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        const rect = ref.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        if (rect.top < windowHeight * 0.7 && rect.bottom > windowHeight * 0.3) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Initial check

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      ref={ref}
      className={`timeline-item flex items-center mb-8 transition-all duration-700 ${
        isVisible ? "visible" : ""
      } ${side === "left" ? "justify-start" : "justify-end"}`}
    >
      <div
        className={`timeline-content w-5/12 p-4 bg-white rounded-lg shadow-md ${
          side === "left" ? "order-1" : "order-2"
        }`}
      >
        <h3 className="font-semibold" style={{ color: "#0B68F2", fontSize: size }}>
          {title}
        </h3>
      </div>
      <div className="timeline-dot"></div>
    </div>
  );
};

const OpportunityTimeline = () => {
  const opportunities = [
    { text: "Reduce Design Time and Cost", size: "20px" },
    { text: "Enable Faster Design Changes", size: "20px" },
    { text: "Adopt to Customer Demands", size: "20px" },
    { text: "AI Utilization to Generate Faster Responses", size: "20px" },
    { text: "Structured Data Inputs for AI", size: "20px" },
    { text: "Get Key Inputs from Experts in China", size: "20px" },
    { text: "Medium Talent at Lower Cost in India", size: "20px" },
    { text: "Strong Indian Team to Generate AI Engines & Models", size: "20px" },
    { text: "Work on Modularizing Designs", size: "20px" },
  ];

  return (
    <div className="py-12">
      <h1 className="text-4xl font-bold text-center mb-12" style={{ color: "#000", fontSize:"48px"}}>
        Long Term Opportunities
      </h1>
      <div className="timeline relative container mx-auto">
        {opportunities.map((item, index) => (
          <TimelineItem key={index} title={item.text} size={item.size} side={index % 2 === 0 ? "left" : "right"} />
        ))}
      </div>
    </div>
  );
};

export default OpportunityTimeline;
